import { useApi } from '../../useApi';
import { useQuery } from '@tanstack/react-query';
import { gql } from 'graphql-request';
import { IProduct } from '../../../../interfaces/product/product';

const PAGE_SIZE = 200;

const PRODUCTS_ALL_QUERY = gql`
    query ($skip: Int!, $take: Int!) {
        products(skip: $skip, take: $take) {
            id
            code
            name
            translation
            thumbnail
            pictures
            imageBar
            type
            fields {
                allowPDFOrder
                downloadFile
                endOfLife
                endOfLifeReplacement
                eyeCatcherColour
                wawiArtikelnummer
                eyeCatcherText
                isCollection
                isCommercial
                isStaticProduct
                orderPeriodExpired
                outOfStock
            }
            category {
                id
            }
            discount
            favourite
            specification {
                description
                relatedProducts {
                    id
                    name
                    translation
                    thumbnail
                }
                text
                variable {
                    text
                    headline
                }
            }
            visible
        }
    }
`;

export const useProductsAll = () => {
    const { postGql } = useApi();

    return useQuery(
        ['products', 'all'],
        async () => {
            const allProducts: IProduct[] = [];
            let skip = 0;
            let hasMore = true;

            while (hasMore) {
                const { products } = await postGql<{ products: IProduct[] }>(
                    PRODUCTS_ALL_QUERY,
                    { skip, take: PAGE_SIZE },
                    `productsT${PAGE_SIZE}S${skip}`
                );

                allProducts.push(...products);
                hasMore = products.length >= PAGE_SIZE / 2;
                skip += PAGE_SIZE;
            }

            return allProducts;
        },
        { staleTime: 60000 }
    );
};
